import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {StorageService} from '../../../../services/rest-api/storage.service';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-allevents',
  templateUrl: './allinfo.component.html',
  styleUrls: ['./allinfo.component.scss']
})
export class AllinfoComponent implements OnInit {
  allEventsData: any[] = [];
  eventColor: string;
  slidesData: any[] = [];
  showDeptMenu = false;

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              private router: Router,
              private storage: StorageService,
              private seo: SeoService) {
    this.eventColor= 'event_color';
  }

  ngOnInit(): void {

    this.seo.setMeta('Events Faculty of Humanities & Social Sciences',
      'All events')

    // Load active news
    this._actRoute.paramMap.subscribe(params => {

      const deptId = this._actRoute.snapshot.params.deptId;
      const infoId = this._actRoute.snapshot.params.infoId;

      if(deptId != undefined && infoId != undefined){
        this.getActiveArchiveInfoByDept(deptId, infoId);
        this.showDeptMenu=true;
      } else{
        this.getAllActiveArchiveEvents();
        this.getEventSlider();
        this.showDeptMenu=false
      }
    });
  }

  navigatePage(current: string, param?: number) {
  if (current === 'info') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['/info/'],navigationExtras);
    }
  }


  // Get all information data
  getAllActiveArchiveEvents(){
    this._info.getActiveArchiveInfo(2).subscribe (
      (response: HssResponse<any>) => {
        this.allEventsData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get information data
  getActiveArchiveInfoByDept(deptId: number, infoId: number){
    this._info.getActiveArchiveInfoByDept(deptId, infoId).subscribe (
      (response: HssResponse<any>) => {
        this.allEventsData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
  // Get slider for EVENTS slider ID = 4
  getEventSlider(){

    const facultydata = this.storage.getData('facultyData');
    const faculty = facultydata ? JSON.parse(facultydata): [];

    this._info.getSlides(faculty[0].event_slider).subscribe (
      (response: HssResponse<any>) => {
        this.slidesData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
